module.exports = __webpack_public_path__ + "img/44914992000138.acf97829.png";